import { store } from "../../../store/store";
import { loaderModal } from "../AlertLoaderService";
import { doPost as omsDoPost, doPostGuest as omsGuestDoPost } from "../api/OMSAPI";
import { getSelectedChemistStoreId } from "../chemist/ChemistStoreUtils";

export function listStoreDeals(isUserLoggedIn,
    { pageNumber = 0, cursorAdvancementCounter = 0, searchWord = '', categoryId = 0 }) {
    const reduxState = store.getState();
    let params = {
        origin: location.host,
        pageNumber: pageNumber,
        category: categoryId, searchWord: searchWord,
        cursorAdvancementCounter: cursorAdvancementCounter,
        pharmacyId: getSelectedChemistStoreId(reduxState)
    }
    return new Promise((resolve) => {
        if (isUserLoggedIn)
            omsDoPost('search/v2301/list_store_products', params).then(
                (response: any) => {
                    if (response && response?.results)
                        resolve({
                            deals: response.results,
                            counter: response?.cursorAdvancementCounter ?? 0
                        })
                    else resolve({ deals: [], counter: 0 })
                }, (err: any) => {
                    resolve({ deals: [], counter: 0 });
                }
            )
        else omsGuestDoPost('v2301/list_store_products', params).then(
            (response: any) => {
                if (response && response?.results)
                    resolve({
                        deals: response.results,
                        counter: response?.cursorAdvancementCounter ?? 0
                    })
                else resolve({ deal: [], counter: 0 })
                loaderModal.setLoader(false);
            }, (err: any) => {
                resolve({ deal: [], counter: 0 });
                loaderModal.setLoader(false);
            }
        )
    })
}